export enum ETheme {
  FO,
  TIDE,
}

export enum EThemeV2 {
  LIGHT_BLUE = 'Light blue',
  DARK_BLUE = 'Dark blue',
}
